import React, { createContext, useContext, useState, useCallback } from "react";

interface Alert {
  type: "success" | "error";
  message: string;
}

interface AlertContextType {
  alert: Alert | null;
  showSuccess: (message: string) => void;
  showError: (message: string) => void;
  clearAlert: () => void;
}

const AlertContext = createContext<AlertContextType | undefined>(undefined);

export const AlertProvider = ({ children }: { children: React.ReactNode }) => {
  const [alert, setAlert] = useState<Alert | null>(null);

  const showSuccess = useCallback((message: string) => {
    setAlert({ type: "success", message });
  }, []);

  const showError = useCallback((message: string) => {
    setAlert({ type: "error", message });
  }, []);

  const clearAlert = useCallback(() => {
    setAlert(null);
  }, []);

  return (
    <AlertContext.Provider value={{ alert, showSuccess, showError, clearAlert }}>
      {children}
    </AlertContext.Provider>
  );
};

export const useAlert = (): AlertContextType => {
  const context = useContext(AlertContext);
  if (!context) {
    throw new Error("useAlert must be used within an AlertProvider");
  }
  return context;
};

export default AlertContext;
